// Builds a copy-ready row for the dbt mapping SEED, matching the VERIFIED production schema:
//   arenasports-dbt/seeds/team_lk_si_level_mapping.csv
//   columns (exact order): com_code,team_name_pattern,level_id,priority,is_active
// Season Manager NEVER writes this file. This util only produces text the auditor pastes into the
// seed themselves, then commits + rebuilds via the existing dbt/Fivetran workflow. is_active is
// always 1 (a proposed rule is authored active; deactivation is a separate manual seed edit).

export const RULE_SEED_PATH = 'arenasports-dbt/seeds/team_lk_si_level_mapping.csv';
export const RULE_CSV_HEADER = 'com_code,team_name_pattern,level_id,priority,is_active';

// RFC4180 field: quote only when the value contains a comma, quote, CR or LF; double embedded quotes.
function csvField(value) {
  const s = value == null ? '' : String(value);
  return /[",\r\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
}

// Validate a rule draft against the seed's required/typed columns. Returns an array of human-readable
// error strings (empty === valid). Kept in sync with the matcher's expectations (see design doc §Slice 2).
export function validateRuleDraft(draft = {}) {
  const errors = [];
  const pattern = draft.team_name_pattern == null ? '' : String(draft.team_name_pattern).trim();
  if (!pattern) errors.push('Pattern is required.');

  const comCode = draft.com_code == null ? '' : String(draft.com_code).trim();
  if (!comCode) errors.push('Franchise scope is required (use * for all franchises).');

  const levelId = draft.level_id;
  if (levelId == null || levelId === '' || !Number.isInteger(Number(levelId))) {
    errors.push('A canonical level must be selected.');
  }

  const priority = draft.priority;
  if (priority == null || priority === '' || !Number.isInteger(Number(priority)) || Number(priority) < 1) {
    errors.push('Priority must be a whole number >= 1 (lower = higher precedence).');
  }
  return errors;
}

// Produce the exact CSV row. Throws if the draft is invalid so a bad row can never be copied.
export function buildRuleCsvRow(draft = {}) {
  const errors = validateRuleDraft(draft);
  if (errors.length) throw new Error(`Cannot build rule row: ${errors.join(' ')}`);
  const fields = [
    csvField(String(draft.com_code).trim()),
    csvField(String(draft.team_name_pattern).trim()),
    csvField(Number(draft.level_id)),
    csvField(Number(draft.priority)),
    '1',
  ];
  return fields.join(',');
}
